
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import {  FaUser,
  FaBriefcase,
  FaBuilding,
  FaPhone,
  FaShareAlt,
  FaMailchimp,
  FaAddressBook, } from "react-icons/fa";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import { Col, Container, Row } from "react-bootstrap";

import "./TeamList.css"
const TeamList = () => {
  const [teamMembers, setTeamMembers] = useState([]);


  const [showShareOptions, setShowShareOptions] = useState(false);
  const [recipient, setRecipient] = useState("");
  useEffect(() => {
    const fetchTeamMembers = async () => {
      const querySnapshot = await getDocs(collection(db, "teamMembers"));
      const members = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setTeamMembers(members);
    };





    fetchTeamMembers();
  }, []);



const formatPhone = v => {
    const d = v.replace(/\D/g, "");
    if (d.length !== 10) return v;
    return `(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6)}`;
  };



  const toggleShareOptions = () => {
    setShowShareOptions(!showShareOptions);
  };

  const formatPhoneFromFirebase = (value) => {
    const digits = value.replace(/\D/g, ""); // Remove non-digits
    if (digits.length !== 10) return value;  // Return original if not 10 digits
  
    const area = digits.slice(0, 3);
    const prefix = digits.slice(3, 6);
    const line = digits.slice(6);
  
    return `(${area}) ${prefix}-${line}`;
  };




// 1) build vCard string
   // build vCard text


  // 2) build a blob URL for download
  // const vCardUrl = member => {
  //   const blob = new Blob([buildVCard(member)], { type: "text/vcard" });
  //   return URL.createObjectURL(blob);
  // };


 // create the blob URL once
  
  
  

  return (
    <Container className="mb-2 py-2">
    {/* <div className="container mt-5 py-2"> */}
      {/* <div className="row"> */}
        <Row className="g-2">
        {teamMembers.map((member) => {


  const vcardText = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${member.lname};${member.name}`,
    `FN:${member.name} ${member.lname}`,
    member.Telephone && `TEL;TYPE=CELL:${member.Telephone}`,
    member.email && `EMAIL;TYPE=INTERNET:${member.email}`,
    "END:VCARD",
  ]
    .filter(Boolean)
    .join("\r\n");
    

    const vcardBlobUrl = URL.createObjectURL(
    new Blob([vcardText], { type: "text/vcard" })
  );



          const contactText = `${member.name} ${member.lname}\nPhone: ${member.Telephone}`;

          const shareContact = () => {
            if (navigator.share) {
              navigator
                .share({
                  title: "Contact Info",
                  text: contactText,
                })
                .then(() => console.log("Shared successfully"))
                .catch((error) => console.error("Error sharing", error));
            } else {
              alert("Sharing not supported on this device/browser.");
            }
          };

          const sendViaSMS = () => {
            window.location.href = `sms:${recipient}?body=${encodeURIComponent(contactText)}`;
          };

          const sendViaWhatsApp = () => {
            const url = `https://wa.me/${recipient}?text=${encodeURIComponent(contactText)}`;
            window.open(url, "_blank");
          };

          return (
            // <div className="col-md-4 col-sm-12 col-xs-12 mb-4" key={member.id}>

              <Col xs={12} md={12} lg={4} s={12} className="my-3 mt-5 mb-5" >

              <div className="card h-100 " style={{ padding: 0 }}>



{/* <h3 className="h5"></h3> */}
                  
                <img
                  src={member.imageUrl || "/default-profile.jpg"}
                  className="card-img-top"
                  alt={`${member.name} ${member.lname}`}
                />
                <div className="card-body">
                  <h3 className="card-title btn-gnbank h1">
                    <FaUser className="me-2" />
                    {member.name} {member.lname}
                  </h3>
                  <p className="card-text btn-gnbank h5">
                    <FaBriefcase className="me-2" />
                    {member.role}
                  </p>
                  <p className="card-text btn-gnbank h5">
                    <FaBuilding className="me-2" />
                    {member.department}
                  </p>
                  <p className="card-text btn-gnbank">
                    <FaPhone className="me-2" />
                    {/* {member.Telephone} */}

                    {formatPhoneFromFirebase(member.Telephone)}
                  </p>
                  <p className="py-0">

          <FaBriefcase className="me-2" />
 
   <a href={member.url} >Send Me A Message</a>
   
   

                  </p>


                  <p className="card-text btn-gnbank">
                    <FaMailchimp className="me-2" />
                    {/* {member.Telephone} */}

                   {member.email}
                  </p>
                 
                 

                  <Link to={`/team/${member.lname}`} className=" mt-2 btn button-gn  me-2">
                    View Profile
                  </Link>

                 

                  <button
                    className="btn btn-outline-secondary mt-2"
                    onClick={toggleShareOptions}
                  >
                    <FaShareAlt className="me-1" /> {showShareOptions ? "Hide" : "Share"} 
                  </button>







  <a 
                  href={vcardBlobUrl}
                  download={`${member.name}-${member.lname}.vcf`}
                  className="btn btn-outline-info mt-2 me-2 top-connect"
                  onClick={e => {
                    // revoke after download
                    setTimeout(() => URL.revokeObjectURL(vcardBlobUrl), 5000);
                  }}
                >
                  <FaAddressBook className="me-1" />
                  Save to Contacts
                </a>



{showShareOptions && (



              
                    <div className="mt-3">
                  <input
                    type="tel"
                    className="form-control mt-3"
                    placeholder="Enter recipient number"
                    value={recipient}
                    onChange={(e) => setRecipient(e.target.value)}
                  />

                  <button onClick={sendViaSMS} className="btn btn-primary mt-2 me-2">
                    Send via SMS
                  </button>
                  <button onClick={sendViaWhatsApp} className="btn btn-success mt-2">
                    Send via WhatsApp
                  </button>
                </div>

)}
                  </div>

             

              
              </div>
            
            {/* </div> */}

            </Col>
          );
        })}
      {/* </div> */}
    {/* </div> */}
    </Row>
    </Container>
  );
};

export default TeamList;
